import { Card, CardEyebrow, CardTitle, CardContent } from '@bookrcs/ui';

export default function StudioRoute() {
  return (
    <div className="grid gap-6 max-w-4xl">
      <header>
        <p className="text-[var(--text-muted)] m-0">Studio</p>
        <h1 className="font-serif text-4xl md:text-5xl font-extrabold m-0 mt-1 text-[var(--text)]">
          Avant / Après
        </h1>
      </header>

      <Card>
        <CardEyebrow>Photos & templates</CardEyebrow>
        <CardTitle>À venir</CardTitle>
        <CardContent>
          <p className="text-[var(--text-muted)] m-0">
            Capture rapide d'une photo avant/après, brief auto au client, copier-coller des captions
            Insta calibrées sur la prestation. Stockage Object Storage Scaleway via{' '}
            <code className="font-mono text-[var(--text)]">/photos</code> (T6.5).
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
